export const Icon = ({index}) => {
	return [...Array(index)].map((_, i) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			width="8" height="8"
			style={{margin: 1}} key={i}
		>
			<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/>
		</svg>
	))
}